import React, { useState } from "react";
import { Box } from "@mui/material/";
import { useParams } from "react-router-dom";
import Checked from "./Checked.js";
import Unchecked from "./Unchecked.js";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";
import config from "../../config";
import { useTranslation } from "react-i18next";
import useDataUnChecked from "./useDataUnchecked";
import useDataChecked from "./useDataChecked";

const Assets = ({ assetListType }) => {
    const { auditId } = useParams();
    const classes = makeStyles(styles)();
    const { t } = useTranslation();

    const [uncheckedShown, setUncheckedShown] = useState(10);
    const [checkedShown, setCheckedShown] = useState(10);

    const [uncheckedCount, dataUnchecked] = useDataUnChecked(uncheckedShown);
    const [checkedCount, dataChecked] = useDataChecked(auditId, checkedShown);

    const hdlShowMore = () => {
        const moreOffset = config.asset.moreOffset;

        if (assetListType === "checked") {
            const incrementBy =
                checkedCount > checkedShown + moreOffset
                    ? moreOffset
                    : checkedCount - checkedShown;
            setCheckedShown(checkedShown + incrementBy);
        } else {
            // unchecked
            const incrementBy =
                uncheckedCount > uncheckedShown + moreOffset
                    ? moreOffset
                    : uncheckedCount - uncheckedShown;
            setUncheckedShown(uncheckedShown + incrementBy);
        }
    };

    return (
        <Box sx={{ typography: "body1" }} className={classes.boxWrp}>
            {assetListType === "checked" ? (
                <>
                    <Checked
                        data={dataChecked}
                        hdlShowMore={hdlShowMore}
                        className={
                            checkedShown >= checkedCount
                                ? classes.hideMoreBtn
                                : classes.showMoreBtn
                        }
                    />
                </>
            ) : (
                <>
                    <Unchecked
                        data={dataUnchecked}
                        hdlShowMore={hdlShowMore}
                        className={
                            uncheckedShown >= uncheckedCount
                                ? classes.hideMoreBtn
                                : classes.showMoreBtn
                        }
                    />
                </>
            )}
        </Box>
    );
};

export default Assets;
